import { Tooltip, styled } from "@mui/material";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip classes={{ tooltip: className }} {...props} />
))(({ theme, visible }) => ({
  fontSize: "14px",
  lineHeight: "19px",
  padding: "2px 12px 3px 12px",
  width: "fit-content",
  maxWidth: "95vw",
  marginTop: "9px",
  visibility: visible ? "visible" : "hidden",
  opacity: visible ? 1 : 0,
  transition: "opacity 0.3s ease, visibility 0.3s ease",
}));

export const CustomTip = styled(({ className, ...props }) => (
  <Tooltip classes={{ tooltip: className }} {...props} />
))(({ theme }) => ({
  fontSize: "14px",
  lineHeight: "19px",
  padding: "2px 12px 3px 12px",
  width: "fit-content",
  maxWidth: "95vw",
  marginTop: "9px",
  visibility: "visible",
  opacity: 1,
  transition: "opacity 0.3s ease, visibility 0.3s ease",
}));

const TooltipCustom = (props) => {
  const { arrow, title, children, isVisible } = props;

  return title ? (
    <CustomTooltip
      title={
        <div>
          {title?.split("\n").map((paragraph, index) => (
            <p key={index} style={{ minHeight: "12px" }}>
              {paragraph}
            </p>
          ))}
        </div>
      }
      arrow={arrow}
      visible={isVisible}
      enterDelay={500}
      enterNextDelay={500}
      leaveDelay={0}
    >
      {children}
    </CustomTooltip>
  ) : (
    children
  );
};

export default TooltipCustom;
